{
  "name": "@mmt/event-logger",
  "version": "0.0.12-xdm",
  "source": "src/index.ts",
  "types": "dist/index.d.ts",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "scripts": {
    "test": "jest",
    "lint": "eslint . --fix",
    "build": "tsup src/index.ts --sourcemap --minify --format esm,cjs",
    "clean": "rm -rf ./dist",
    "dev": "tsup src/index.ts --sourcemap --format esm,cjs --dts",
    "dev:watch": "tsup src/index.ts --sourcemap --format esm,cjs --dts --watch",
    "prepublishOnly": "yarn build"
  },
  "dependencies": {
    "@mmt/events-schema": "0.0.6-xdm",
    "ua-parser-js": "^1.0.36",
    "uuid": "^9.0.0"
  },
  "peerDependencies": {
    "pako": "^2.1.0"
  },
  "devDependencies": {
    "@swc/core": "^1.3.95",
    "@types/pako": "^2.0.0",
    "@types/ua-parser-js": "^0.7.37",
    "jsdom": "^21.1.1",
    "parcel": "latest",
    "tsup": "^7.2.0"
  }
}
